// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__F6xLM","badge":"Card_badge__z1q_M"};